import {Link} from "react-router-dom";

const dgisCompanyUrl = "https://2gis.ru/krasnoyarsk/firm/70000001113736988";

function Address() {
    return (
        <main className="address-page">
            <section className="address-hero">
                <div className="address-hero-content">
                    <span className="address-eyebrow">Адрес сервиса</span>
                    <h1>Как нас найти</h1>
                    <p className="address-hero-description">
                        Трак-Центр 24 находится в Красноярске. Ниже указан адрес текстом и ссылка на карточку компании в 2GIS.
                    </p>
                </div>

                <Link className="address-home-link" to="/">
                    На главную
                </Link>
            </section>

            <section className="address-card" aria-label="Адрес компании">
                <div>
                    <span className="address-card-label">Адрес</span>
                    <h2>Красноярск, Рязанская улица, 7 ст9</h2>
                    <p>
                        Откройте карточку компании в 2GIS, чтобы построить маршрут, посмотреть вход и уточнить данные на карте.
                    </p>
                </div>

                <a
                    className="address-dgis-link"
                    href={dgisCompanyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Открыть компанию в 2GIS
                </a>
            </section>
        </main>
    );
}

export default Address;
